import { useRef, useState} from "react";
import {useData} from "./Calendar";
import {ControlledMenu,  MenuItem} from "@szhsin/react-menu";
import StatusModal, {INSPECTION_STATES, STATE_DENIED} from "./StatusModal";
import {Badge, ProgressBar} from "react-bootstrap";
import ProtocolsModal from "./ProtocolsModal";
import {useAuth} from "../../providers/authprovider";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTriangleExclamation, faFileInvoiceDollar, faFileInvoice, faComment} from "@fortawesome/free-solid-svg-icons";
import {getUserInitials} from "../../utils/utils";
import Notes from "../buildings/Notes";
import NotesModal from "./NotesModal";
import { useNavigate} from "react-router-dom";

export function getInspectionFrequencyName(num){

    const freq = Number(num);


    switch (freq){
        case 12:
            return "miesięczny";
        case 4:
            return "kwartalny";
        case 2:
            return "półroczny";
        case 1:
            return "roczny";
        case 0.33:
            return "trzyletni";
        case 0.2:
            return "pięcioletni";
        default:
            return "inny";
    }
}



export function getEventHeader({type, time}){

    let timeSpan = time !== null ? <b className={"float-end"}>{time}</b> : '';

    switch (type){
        case 'MALFUNCTION' : return <div className={"malfunction_header"}>Zgłoszenie/Awaria</div>;
        case 'TRAINING': return <div className={"training_header"}>Szkolenie {timeSpan}</div>;
        default: return null;
    }
}

export function  progress(event){
    switch (event.state){
        case INSPECTION_STATES.CONFIRMATION:
            return 25;
        case STATE_DENIED:
            return 10;
        case INSPECTION_STATES.USER_CONFIRMATION:
            return 50;
        case INSPECTION_STATES.REALIZATION:
            return 75;
        case INSPECTION_STATES.FINISHED:
            return 100;
        default:
            return 0;
    }
}

export function getProgressTitle(event){
    switch (event.state){
        case INSPECTION_STATES.CONFIRMATION:
            return "Ustawiono termin przeglądu";
        case INSPECTION_STATES.USER_CONFIRMATION:
            return "Użytkownik potwierdził/odrzucił termin";
        case INSPECTION_STATES.REALIZATION:
            return "Zrealiowano przegląd";
        case INSPECTION_STATES.FINISHED:
            return "Zlecenie zakończozne.";
        case STATE_DENIED:
            return "Odrzucono termin"
        default:
            return "Brak statusu";
    }
}

export   function isInspection(event){
    return event.type === 'INSPECTION';
}

export default function Event({event, onClick,day,currentdate, privilege, onDelete}){

    const maxSpan = 7-day+1
    const daysTilEnd = calculateDaysTillEventEnd(event.date_to, currentdate);
    const span = Math.min(maxSpan, daysTilEnd+1)
    const {user, calendar : {remove}} = useAuth();
    const { workers, handleSuccessAddEdit, shortBuildings} = useData();
    const ref = useRef(null);
    const [isOpen, setOpen] = useState(false);
    const [showStatusModal, setShowStatusModal] = useState(false);
    const [protocolsModal, setShowProtocolsModal] = useState(false);
    const [notesModal, setShowNotesModal] = useState(false);
    const [showBuildingHistory, setShowBuildingHistory] = useState(false)
    const navigate = useNavigate();
    const isConfirmed = event.confirmed ? "confirmed" : "notConfirmed";
    let users = [];




    if(event.users)
        users = workers.filter(w=>event.users.includes(w.id));

    const eventHeader = getEventHeader(event);


    const handleClick = ()=>{
        setOpen(true);
    }

    const handleDeleteEvent = ()=>{
        // if(isInspection(event))
        //     return window.alert("Nie można usunąć zaplanowanej inspekcji.")

        if(!window.confirm("Potwierź usunięcie inspekcji/awarii z kalendarza.")) return

        remove(event.id, ({success, error, content})=>{

            if(success === true)
                return onDelete(event)
        })
    }

    function getBuildingShortData(){
        const building = shortBuildings.find(b=>b.id === event.building_id);
        if(!building)
            return {id:"", name:""};

        return {id:building.id, name:building.name};
    }


    const handleShowBuildingHistory = (event)=>{
        event.stopPropagation()
        event.preventDefault()
        setShowBuildingHistory(true)
    }

    const handleOpenBuilding = (event)=>{
        navigate(`/buildings/${event.building_id}`);
    }

    const openEventNotesModal = (event)=>{
        setShowNotesModal(true)
    }

    const variant = event.state === STATE_DENIED ? 'danger' : 'success';
    const animated = event.state === STATE_DENIED;
    const stateDenied = event.state === STATE_DENIED ? <Badge bg="danger" className={"mb-1"}><FontAwesomeIcon icon={faTriangleExclamation}/> Odrzucono termin</Badge> : ""





    return (
        <>
            {
                showBuildingHistory &&
                <Notes building={getBuildingShortData()} onHide={()=>setShowBuildingHistory(false)} />
            }
            <div ref={ref} className={`day_${day}  event ${isConfirmed}  span_${span}`} onClick={handleClick}>
                <ControlledMenu
                    state={isOpen ? 'open' : 'closed'}
                    anchorRef={ref}
                    align={'start'}
                    direction={"bottom"}
                    arrow={true}
                    onMouseLeave={() => setOpen(false)}
                    onClose={() => setOpen(false)}
                >
                    {
                        privilege.edit ?
                            <MenuItem onClick={onClick}>Edycja</MenuItem>
                            :
                            <MenuItem onClick={onClick}>Podgląd</MenuItem>
                    }
                    <MenuItem onClick={()=>setShowStatusModal(true)}>Status</MenuItem>
                    {
                        event.building_id && <MenuItem onClick={()=>handleOpenBuilding(event)}>Obiekt</MenuItem>
                    }
                    {
                        event.confirmed  ?
                            <MenuItem onClick={()=>setShowProtocolsModal(true)}>Protokoły</MenuItem> :  null
                    }
                     <MenuItem onClick={openEventNotesModal}>Notatka</MenuItem>
                    {
                        user.isAdmin &&
                            <MenuItem onClick={handleDeleteEvent}>Usuń</MenuItem>
                    }

                </ControlledMenu>

                <div className={"eventBody"}  >
                    <div className={"d-inline-block float-end"}>
                    {
                            event.hasNotes > 0 ?
                                <FontAwesomeIcon className={"fs-3 m-2 text-secondary "} icon={faComment} title={"Notatki"} onClick={()=>openEventNotesModal()} />
                                : null
                        }
                        {
                            event.offers !== undefined && event.offers.length > 0 ?
                                <FontAwesomeIcon className={"fs-3 m-2 text-info "} icon={faFileInvoice} title={"Oferta"} />
                                : null
                        }
                        {
                            (event.fvat || event.fvat_submit) ?
                                <FontAwesomeIcon className={`fs-3 m-2 ${event.fvat  ? 'text-success' : 'text-muted'}`} icon={faFileInvoiceDollar} title={event.fvat_description} />
                                : null
                        }
                    </div>

                    {eventHeader}

                    <div className={"eventNameLine"} title={event.name} onClick={handleShowBuildingHistory}><u>{event.name}</u></div>
                    <div className={"text-muted"}><small>{event.inspectionName}</small></div>

                    {
                        users?.map(user=>
                            <span key={user.id} className={"userBadge"} style={{backgroundColor:user.color}} title={user.name}>{getUserInitials(user)}</span>
                        )
                    }
                    {
                        isInspection(event) &&
                        <div className={"w-100 text-end pe-2"}><small><small><b>{getInspectionFrequencyName(event.frequency)}</b></small></small></div>
                    }
                    {
                        stateDenied
                    }
                    <ProgressBar animated={animated} now={progress(event)} variant={variant} title={getProgressTitle(event)} className={"statusProgressBar"} />
                    <small className={"text-muted"}><i>{event.info}</i></small>
                </div>

            </div>
            {
                showStatusModal &&
                <StatusModal show={true} event={event} onHide={()=>setShowStatusModal(false)}
                             onChangeEvent={handleSuccessAddEdit} />
            }
            {
                protocolsModal &&
                <ProtocolsModal show={protocolsModal} event={event} onHide={()=>setShowProtocolsModal(false)} />
            }
            {
                notesModal &&
                <NotesModal show={notesModal} event={event} onHide={()=>setShowNotesModal(false)} />
            }
        </>


    )
}

function calculateDaysTillEventEnd(dateTo, currentDate){

    const timeSpanTo = Date.parse(dateTo.split('T')[0])
    const timeSPanCurrent = Date.parse(currentDate.toJSON().split('T')[0])
    return ((timeSpanTo - timeSPanCurrent)/1000)/(24*3600);
}